import React, { useState } from 'react';
import {useParams} from 'react-router-dom';
import SubHeader from '../../components/SubHeader';
import {useProjectStore} from '@/stores/project'
import History from '@/components/Dashboard/History';
import SaleApply from '@/components/Dashboard/SaleApply';
import DrmPf from '@/components/Dashboard/DrmPf';
import Navi from '@/components/Dashboard/Navi';
import ServiceStart from '@/components/Dashboard/ServiceStart';
import * as Config from '@/config'
import moment from "moment/moment";

export interface DashboardProps {
  projectId: number;
  startDate: string;
  endDate: string;
}

const Dashboard: React.FC = () => {
  const params = useParams();
  
  const [
    selectedProject,
    selectedProjectCategory, 
    selectedSubProjectCategory,
    setSelectedSubProjectCategory,
  ] = useProjectStore(state => [
    state.project,
    state.projectCategory,
    state.subProjectCategory,
    state.setSubProjectCategory,
  ]);

  const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
  const endOfMonth   = moment().endOf('month').format('YYYY-MM-DD');

  const [inputStartDate, setInputStartDate] = useState(startOfMonth);
  const [inputEndDate, setInputEndDate] = useState(endOfMonth);

  const [filterStartDate, setFilterStartDate] = useState(startOfMonth);
  const [filterEndDate, setFilterEndDate] = useState(endOfMonth);

  const handleFilter = () => {
      setFilterStartDate(inputStartDate);
      setFilterEndDate(inputEndDate);
  };

  const renderDashboard = () => {
    const projectId = Number(params.projectId) ?? -1;
    const props = {
      projectId,
      startDate: filterStartDate,
      endDate: filterEndDate
    };
    switch (projectId) {
      case Config.PROJECT_ID_HISTORY:
        return <History {...props} />;
      case Config.PROJECT_ID_SALE_APPLY:
        return <SaleApply {...props} />;
      case Config.PROJECT_ID_DRM_PF:
        return <DrmPf {...props} />;
      case Config.PROJECT_ID_NAVI:
        return <Navi {...props} />;
      case Config.PROJECT_ID_SERVICE_START:
        return <ServiceStart {...props} />;
      default:
        return <p>選択されたプロジェクトのダッシュボードは存在しません。</p>;
    }
  };

  const breadCrumbs = [
    {title: selectedProject?.name},
    {title: selectedProjectCategory?.name}
  ];

  return (
    <div className="">
		  <div className="sub-header">
			  <SubHeader breadCrumbs={breadCrumbs}/>
      </div>
      <div className='dashboard container'>
        <div className="dashboard-header">
          <div></div>
          
          <table className="">
            <tbody>
              <tr>
                <td className="header">照会年月日</td>
                <td className="">
                  <input
                    type="date"
                    value={inputStartDate}
                    onChange={(e) => setInputStartDate(e.target.value)}
                    className="date-input"
                  />
                  <span className="date-filter-separator">&nbsp;〜&nbsp;</span>
                  <input
                    type="date"
                    value={inputEndDate}
                    onChange={(e) => setInputEndDate(e.target.value)}
                    className="date-input"
                  />
                  <button className="uk-button--m uk-button-refer uk-margin-left" onClick={handleFilter}>絞込</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <main className="dashboard-main">
          {renderDashboard()}
        </main>
      </div>
    </div>
  );
};

export default Dashboard;